import {Select, Button} from 'antd';
import React from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {IconWrapper} from '../../../IconWrapper';
import {CloseOutlined} from "@ant-design/icons";

const {Option} = Select;

export const UsersFilter = ({handleChange, users, filters, clearAndClose}) => {
  return (
    <div className="campaigns-page__filter-wrapper">
      <IconWrapper>
        <FontAwesomeIcon icon={['fas', 'users']} />
      </IconWrapper>
      <Select
        mode="multiple"
        maxTagCount={1}
        placeholder="Select users"
        onChange={handleChange}
        value={users.length > 0 ? filters.users : undefined}
        className="campaigns-page__filter-input"
      >
        {users.map(user => (
          <Option key={user.id}>
            {user.first_name ? `${user.first_name} ${user.last_name}` : user.email}
          </Option>
        ))}
      </Select>
      <Button onClick={clearAndClose} icon={<CloseOutlined/>} type="link" className="campaigns-page__close-filter" size="small" />
    </div>
  );
};
